export const $apiUrl = "https://auth.honari.com";
export const $shopUrl = "https://honari.com";
export const $cookieURL = "honari.com";
export const $authUrl = "https://auth.honari.com";
export const $loginPage = "https://honari.com/user";
export const $class_next_url = "https://honari.com/academy";
